import { all } from "redux-saga/effects";
import {
  updatePermissionsWatcher,
  userCreateWatcher,
  userDeleteWatcher,
  userEditWatcher,
  userModCreateWatcher,
  userModPermissionsWatcher,
  userPermissionsWatcher,
  userTableWatcher,
  userViewWatcher,
} from "../user-saga";

export default function* userRootSaga() {
  yield all([
    userCreateWatcher(),
    userModCreateWatcher(),
    userTableWatcher(),
    userViewWatcher(),
    userEditWatcher(),
    userDeleteWatcher(),
    userPermissionsWatcher(),
    userModPermissionsWatcher(),
    updatePermissionsWatcher(),
  ]);
}
